<template>
  <fieldset class="groups" v-if="variables['group-list']" v-for="group in variables['group-list'].value" :key="group.id">

    <legend @click="group.hide = !group.hide" :style="'background-image: url(' +
      $model.wwwroot +
      '/pix/t/' +
      (group.hide ? 'collapsed.png' : 'expanded.png') +
      ')'
      ">
      Группа: {{ group.name }}
    </legend>

    <!-- список студентов -->
    <v-autocomplete v-if="!group.hide" :items="group.allStudents" v-model="group.selectedStudents" max-width="500" :multiple="true"
      item-title="name" return-object variant="outlined">
    </v-autocomplete>

    <!--
    <multiselect v-if="!groups.hide" v-model="groups.selectedStudents" :close-on-select="true" track-by="id"
      :multiple="multipleStudent" label="name" :options="groups.students" :disabled="state == 3" group-values="values"
      group-label="group" :group-select="true" @select="studentSelect"></multiselect>
      -->
  </fieldset>
</template>

<script>
export default {
  name: "enrollment",
  data() {
    return {

    };
  },
  props: {
    selectedGroups: {
      type: Array,
      required: true,
    },
  },
  created() { },
  methods: {

  },
};
</script>
<style scoped>
.groups legend {
  background-position: left;
  padding-left: 20px;
  cursor: pointer;
  width: auto;
}
</style>